import { useEffect, useState, useCallback } from 'react';
import { onAuthChanged, signInWithEmail, signOut } from './authService';
import type { User } from 'firebase/auth';

export function useAuth() {
  const [user, setUser] = useState<User | null>(() => {
    // Si hay caché, devolvemos un objeto Mock inicial para que la app pase el gateway de inmediato.
    const cached = localStorage.getItem('archicore_cached_session');
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        return { uid: parsed.uid, email: parsed.email } as User;
      } catch (e) {
        return null;
      }
    }
    return null;
  });

  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const unsub = onAuthChanged((u) => {
      setUser(u);
      setInitializing(false);
      // Actualizar la caché en plano si el usuario real cambió o se perdió (Cierre de sesión de 2do plano).
      if (u) {
        localStorage.setItem('archicore_cached_session', JSON.stringify({ uid: u.uid, email: u.email }));
      } else {
        localStorage.removeItem('archicore_cached_session');
      }
    });
    return () => unsub();
  }, []);

  const signIn = useCallback(async (email: string, password: string) => {
    return await signInWithEmail(email, password);
  }, []);

  const logout = useCallback(async () => {
    await signOut();
  }, []);

  return { user, initializing, signIn, signOut: logout, authChecked: !initializing };
}
